import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataSheetReport } from '../../models/reports/data-sheet-report.model';
import { JointCompletionCertificate } from '../../models/reports/joint-completion-certificate.model';
import { ajaxSetup } from '@devexpress/analytics-core/analytics-utils';
import { AsyncExportApproach } from 'devexpress-reporting/scopes/reporting-viewer-settings';
import { DxReportViewerComponent } from 'devexpress-reporting-angular';
import { environment } from 'src/environments/environment';
import { ManagementApiService } from 'src/app/services';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-report-viewer',
    templateUrl: './report-viewer.component.html',
    styleUrls: [
        './report-viewer.component.scss',
        '../../../../../../node_modules/jquery-ui/themes/base/all.css',
        '../../../../../../node_modules/devextreme/dist/css/dx.light.css',
        '../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css',
        '../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css',
        '../../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css',
    ],
    standalone: false
})
export class ReportViewerComponent implements OnInit {
    @Input() reportData: DataSheetReport | JointCompletionCertificate | DataSheetReport[] | JointCompletionCertificate[];
    @Input() reportName: string;
    @ViewChild(DxReportViewerComponent, { static: false }) viewer!: DxReportViewerComponent;
    reportUrl: string;
    invokeAction: string;
    hostUrl: string;

    constructor(
        public ngbActiveModal: NgbActiveModal,
        private managementApiService: ManagementApiService
    ) {
        this.invokeAction = '/DXXRDV';
        // TODO: will add this url to config later once all report setup is done.
        this.hostUrl = environment.reportApp;
        //this.hostUrl = 'https://localhost:44391';

        this.calculateHeight();
    }

    async ngOnInit() {
        if (localStorage.getItem('currentInstanceTypeName').toLowerCase() == 'idms') {
            try {
                let res = await this.managementApiService.getSettingProfileAreaId('iDMS').toPromise();

                if (res.success) {
                    let settingArea = res.response;

                    let _res = await this.managementApiService
                        .getInstanceDefaultSettings(settingArea.settingAreaId, localStorage.getItem('currentInstanceId'))
                        .toPromise();

                    if (_res.success) {
                        var InstanceSettings = _res.response;
                        if (InstanceSettings) {
                            // Find the setting with key "ReportQRCode_Visible"
                            const setting = InstanceSettings.find((item) => item.userPreferenceKey === 'ReportBarcode_Visible');

                            // Extract the "value" from "settingValue" if found
                            const isBarcodeVisible = setting?.userPreference;
                            // Find the setting with key "ReportQRCode_Visible"
                            const _setting = InstanceSettings.find((item) => item.userPreferenceKey === 'ReportQRCode_Visible');

                            // Extract the "value" from "settingValue" if found
                            const isQRcodeVisible = _setting?.userPreference;
                            const isQRVisible = isQRcodeVisible.toLowerCase() === 'true';
                            const isBarcodeVisibleFlag = isBarcodeVisible.toLowerCase() === 'true';

                            if (Array.isArray(this.reportData)) {
                                // Case: Array of rows
                                this.reportData.forEach((row) => {
                                    row.isQRcodeVisible = isQRVisible;
                                    row.isBarcodeVisible = isBarcodeVisibleFlag;
                                });
                            } else if (this.reportData) {
                                // Case: Single object
                                this.reportData['isQRcodeVisible'] = isQRcodeVisible.toLowerCase() == 'true' ? true : false;
                                this.reportData['isBarcodeVisible'] = isBarcodeVisible.toLowerCase() == 'true' ? true : false;
                            }
                            let reportDataJSONString = JSON.stringify(this.reportData);
                            let EncodingString = encodeURIComponent(reportDataJSONString);
                            ajaxSetup.ajaxSettings = {
                                headers: { Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}` },
                                xhrFields: { withCredentials: true },
                            };
                            AsyncExportApproach(true);
                            this.reportUrl = `${this.reportName}?ReportData=${EncodingString}`;
                        }
                    }
                }
            } catch (e) {
                //this.ngxUiLoaderService.stop();
            }
        } else {
            let reportDataJSONString = JSON.stringify(this.reportData);
            let EncodingString = encodeURIComponent(reportDataJSONString);
            ajaxSetup.ajaxSettings = {
                headers: { Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}` },
                xhrFields: { withCredentials: true },
            };
            AsyncExportApproach(true);
            this.reportUrl = `${this.reportName}?ReportData=${EncodingString}`;
        }
    }

    // * adjusting pop-up height dynamically
    calculateHeight() {
        setTimeout(() => {
            let element = document.querySelector('.dx-designer') as HTMLElement;
            element.classList.add('dynamic-height');
        });
    }

    // * set up before loading a report
    operationBeforeRenderReport(event) {
        // event.args.reportPreview.zoom(1);
        const reportPreview = event?.args?.reportPreview;

        if (reportPreview && typeof reportPreview.zoom === 'function') {
            reportPreview.zoom(1); // 1 = 100%
        }
        // const viewer = event.component;
        // if (viewer) {
        //     // Set zoom to 100% (1 = 100%)
        //     // viewer.SetZoom(1);
        //     viewer.option('zoom', -1); // 1 = 100%
        // }
    }

    // async getInstanceSettings() {
    //     try {
    //         let res = await this.managementApiService.getSettingProfileAreaId('iDMS').toPromise();

    //         if (res.success) {
    //             let settingArea = res.response;

    //             let _res = await this.managementApiService
    //                 .getInstanceSettings(settingArea.settingAreaId, localStorage.getItem('currentInstanceId'))
    //                 .toPromise();

    //             if (_res.success) {
    //                 localStorage.setItem('InstanceSettings', JSON.stringify(_res.response));
    //             }
    //         }
    //     } catch (e) {
    //         //this.ngxUiLoaderService.stop();
    //     }
    // }
}
